import { axiosGet } from '@services/api/axios'

export const apiParticipationProfilePdf = async (participationId: number) => {
  return await axiosGet<Blob>(`/external-app-plugin/participations/${participationId}/profile/pdf`, undefined, undefined, 'blob')
}
